import { render, staticRenderFns } from "./sector-department-view.vue?vue&type=template&id=685e5245"
import script from "./sector-department-view.vue?vue&type=script&lang=js"
export * from "./sector-department-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports